import React from "react";

import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";

import SindhPrisonPopulationTrend from "./chart/SindhPrisonPopulationTrend";
import SindhBreakdownPrisoners from "./chart/SindhBreakdownPrisoners";
import SindhTotalPrisoners from "./chart/SindhTotalPrisoners";
import SindhUnderTrialPrisoners from "./chart/SindhUnderTrialPrisoners";
import SindhTypePrisoner from "./chart/SindhTypePrisoner";

function SindhPrisonStatistics() {
  return (
    <div className="py-5">
      <h2 className="text-h-black">Sindh Prison Statistics</h2>
      <div className="row row-cols-1 row-cols-md-4 py-5">
        <div className="col">
          <p className="punjab-static-h">
            <b>Prison Population Trend</b>
          </p>
          <div className="d-flex align-items-end">
            <div>
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={19632} redraw={true} separator=",">
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
              </p>
            </div>
            <div className="ms-2">
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "10px" }}
              >
                by end of Year 2021
              </p>
            </div>
          </div>
          <SindhPrisonPopulationTrend />
        </div>
        <div className="col">
          <p className="punjab-static-h">
            <b>Operating Rate</b>
          </p>
          <div className="d-flex align-items-end">
            <div>
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={145} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
                %
              </p>
            </div>
            <div className="ms-2">
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "10px" }}
              >
                of its authorized capacitys
              </p>
            </div>
          </div>
          <SindhBreakdownPrisoners />
        </div>
        <div className="col">
          <p className="punjab-static-h">
            <b>Prison Population in Sindh</b>
          </p>
          <div className="d-flex align-items-end">
            <div>
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={22.1} redraw={true} decimals={1}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
                %
              </p>
            </div>
            <div className="ms-2">
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "10px" }}
              >
                of the total prison population in Pakistan
              </p>
            </div>
          </div>
          <SindhTotalPrisoners />
        </div>
        <div className="col">
          <p className="punjab-static-h">
            <b>Under-trial Proportion</b>
          </p>
          <div className="d-flex align-items-end">
            <div className="col">
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={16} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
                %
              </p>
            </div>
            <div className="ms-2">
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "10px" }}
              >
                out of all prisoners in Pakistan are under trial in Sindh
              </p>
            </div>
          </div>
          <SindhUnderTrialPrisoners />
        </div>
      </div>

      <div className="row row-cols-1 row-cols-md-3">
        <div className="col">
          <p className="punjab-static-h">
            <b>Significant Percentages </b>
          </p>
          <div className="d-flex">
            <div
              style={{
                display: "flex",
                alignItems: "end",
                marginBottom: "10px",
              }}
            >
              <p
                className="m-0"
                style={{
                  fontSize: "18px",
                  color: "red",
                  fontFamily: "Abril Fatface",
                }}
              >
                High Security Jails =
              </p>
            </div>
            <div>
              <p
                className="m-0 ms-2"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={0} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
              </p>
            </div>
          </div>
          <div className="d-flex">
            <div
              style={{
                display: "flex",
                alignItems: "end",
                marginBottom: "10px",
              }}
            >
              <p
                className="m-0"
                style={{
                  fontSize: "18px",
                  color: "red",
                  fontFamily: "Abril Fatface",
                }}
              >
                Sub-jails/ Judicial lock-ups =
              </p>
            </div>
            <div>
              <p
                className="m-0 ms-2"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={0} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
              </p>
            </div>
          </div>
          <div className="d-flex">
            <div
              style={{
                display: "flex",
                alignItems: "end",
                marginBottom: "10px",
              }}
            >
              <p
                className="m-0"
                style={{
                  fontSize: "18px",
                  color: "red",
                  fontFamily: "Abril Fatface",
                }}
              >
                Juveniles under trial =
              </p>
            </div>
            <div>
              <p
                className="m-0 ms-2"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={93} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
                %
              </p>
            </div>
          </div>
          <div className="d-flex">
            <div
              style={{
                display: "flex",
                alignItems: "end",
                marginBottom: "10px",
              }}
            >
              <p
                className="m-0"
                style={{
                  fontSize: "18px",
                  color: "red",
                  fontFamily: "Abril Fatface",
                }}
              >
                Total Prisoners under trial =
              </p>
            </div>
            <div>
              <p
                className="m-0 ms-2"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={77} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
                %
              </p>
            </div>
          </div>
        </div>
        <div className="col">
          <div>
            <p className="m-0 punjab-static-h">
              <b>TOTAL JAILS</b>
            </p>
            <div className="d-flex align-items-end">
              <div>
                <p
                  className="m-0"
                  style={{
                    fontSize: "38px",
                    color: "#000",
                    fontFamily: "Abril Fatface",
                  }}
                >
                  <CountUp end={26} redraw={true} separator=",">
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                </p>
              </div>
            </div>
            <p className="m-0 punjab-static-h">
              <b>CAPACITY</b>
            </p>
            <div className="d-flex align-items-end">
              <div>
                <p
                  className="m-0"
                  style={{
                    fontSize: "38px",
                    color: "#000",
                    fontFamily: "Abril Fatface",
                  }}
                >
                  <CountUp end={13538} redraw={true} separator=",">
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                </p>
              </div>

              <div className="ms-2">
                <p
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "10px",
                  }}
                >
                  by end of Year 2021
                </p>
              </div>
            </div>

            <p className="m-0 punjab-static-h ">
              <b>PRISONERS</b>
            </p>
            <div className="d-flex align-items-end">
              <div>
                <p
                  className="m-0"
                  style={{
                    fontSize: "38px",
                    color: "#000",
                    fontFamily: "Abril Fatface",
                  }}
                >
                  <CountUp end={19632} redraw={true} separator=",">
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                </p>
              </div>

              <div className="ms-2">
                <p
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "10px",
                  }}
                >
                  by end of Year 2021
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <p className="punjab-static-h">
            <b>Type of Prisons </b>
          </p>
          <SindhTypePrisoner />
        </div>
      </div>
    </div>
  );
}

export default SindhPrisonStatistics;
